import { TILE_SIZE } from "../core/CameraManager";

function deepFreeze<T>(obj: T): T {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  Object.freeze(obj);
  const propNames = Object.getOwnPropertyNames(obj);
  for (const name of propNames) {
    const value = (obj as Record<string, unknown>)[name];
    if (value !== null && typeof value === "object") {
      deepFreeze(value);
    }
  }
  return obj;
}

export { TILE_SIZE };

export const RENDER_PALETTE = deepFreeze({
  background: 0x1a1a2e,
  terrain: {
    solid: 0x4a4a6a,
    empty: 0x252540,
    ladder: 0x8b6914,
    plank: 0x5c4033,
  },
  entities: {
    player: 0x4fc3f7,
    playerFlash: 0xff5252,
    exit: 0x66bb6a,
    collectible: 0xffd54f,
    breadcrumb: 0x80deea,
    portalColors: [
      0xe91e63,
      0x9c27b0,
      0x673ab7,
      0x3f51b5,
      0x2196f3,
      0x00bcd4,
      0x009688,
      0x4caf50,
    ],
  },
  fog: {
    visible: 0,
    explored: 0.5,
    hidden: 0.85,
  },
  effects: {
    burstColors: [0xffd54f, 0xffffff, 0xff9800, 0xff5722] as readonly number[],
    breadcrumbBurstColor: 0x80deea,
  },
});

export function getPortalColor(group: string): number {
  const colors = RENDER_PALETTE.entities.portalColors;
  let hash = 0;
  for (let i = 0; i < group.length; i += 1) {
    hash = ((hash << 5) - hash + group.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index] ?? colors[0]!;
}

export function getFogAlpha(
  state: "visible" | "explored" | "hidden" | "permanentReveal" | "debugReveal",
): number {
  if (state === "permanentReveal" || state === "debugReveal" || state === "visible") {
    return RENDER_PALETTE.fog.visible;
  }
  if (state === "explored") {
    return RENDER_PALETTE.fog.explored;
  }
  return RENDER_PALETTE.fog.hidden;
}
